import { render, staticRenderFns } from "./ui-text.vue?vue&type=template&id=241e9ef8&scoped=true"
import script from "./ui-text.vue?vue&type=script&lang=js"
export * from "./ui-text.vue?vue&type=script&lang=js"
import style0 from "./ui-text.vue?vue&type=style&index=0&id=241e9ef8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241e9ef8",
  null
  
)

export default component.exports